import { Box, Typography } from '@mui/material'

export const demandHints = [
  {
    partner: '*',
    element: () => (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          pt: '0.5em',
          pb: '0.5em'
          // backgroundColor: '#FADF8E',
          // height: '8em'
        }}>
        <Box sx={{ ml: '0.5em', mr: '0.5em' }}>
          <Box sx={{ alignSelf: 'left' }}>
            <Typography variant="subtitle1">
              最大DMを超えると電気料金が上がります。
            </Typography>
          </Box>
          <Box sx={{ alignSelf: 'left' }}>
            <Typography variant="subtitle1">【5kWを超えた場合】</Typography>
            <Typography variant="subtitle1" sx={{ mt: '-0.5em' }}>
              月9,000円、年108,000円のコスト増加
            </Typography>
            <Typography variant="subtitle2" sx={{ mt: '-0.5em' }}>
              ※5KW × 1,800円 = 9,000円/月 × 12ヶ月 = 108,000円
            </Typography>
          </Box>
          <Box
            sx={{ alignSelf: 'left', backgroundColor: '#F1CDCE', mt: '0.5em' }}>
            <Typography
              variant="subtitle1"
              sx={{ textDecoration: 'underline' }}>
              ＜DMを抑制するためには＞
            </Typography>
            <Typography variant="subtitle2">
              複数の電気設備を同時に使用しないようにしてください。
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  }
]
